import React from 'react'
import PropTypes from 'prop-types'
import { StyledButton, Text } from './component.styles'

const NavigatorBubbleButton = ({
  children,
  dataTestId,
  isActive,
  label,
  onClick,
}) => {
  return (
    <StyledButton
      data-testid={dataTestId}
      isActive={isActive}
      label={label}
      onClick={onClick}
    >
      <Text isActive={isActive}>{children}</Text>
    </StyledButton>
  )
}

NavigatorBubbleButton.propTypes = {
  children: PropTypes.node,
  dataTestId: PropTypes.string,
  isActive: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
}

export default NavigatorBubbleButton
